import Sunset from "../../../../contents/docs/self-host/_snippets/sunset-disclaimer.mdx";
import CommandHelmGetRepoSnippet from "../../../../contents/docs/self-host/_snippets/command-helm-get-repo.mdx";
import CommandHelmUpgradeSnippet from "../../../../contents/docs/self-host/_snippets/command-helm-upgrade.mdx";
import * as React from 'react';
export default {
  Sunset,
  CommandHelmGetRepoSnippet,
  CommandHelmUpgradeSnippet,
  React
};